import React from 'react'

const useDebounce = (value, handler = () => {}, delay = 500) => {
  const firstRender = React.useRef(true)
  const debounceHandler = React.useRef(handler)
  debounceHandler.current = handler

  React.useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }

    const timeout = setTimeout(() => {
      debounceHandler.current(value)
    }, delay)

    return () => {
      clearTimeout(timeout)
    }
  }, [value, delay])
}

export default useDebounce
